import React from "react";
import PublicNav, { PublicFooter } from "@/components/PublicNav";
import { Link } from "react-router-dom";

export default function MarketingPage({ eyebrow, title, subtitle, children, cta = true }) {
  return (
    <div className="min-h-screen pt-14 text-slate-100">
      <PublicNav />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 fx-grid-bg opacity-30 pointer-events-none"/>
        <div className="max-w-6xl mx-auto px-5 pt-16 pb-10 relative">
          {eyebrow && <div className="mono text-xs uppercase tracking-[0.24em] text-cyan-300 mb-4">{eyebrow}</div>}
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl">{title}</h1>
          {subtitle && <p className="mt-5 text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-5 py-8">{children}</section>
      {cta && (
        <section className="max-w-4xl mx-auto px-5 py-16">
          <div className="fx-panel p-10 text-center">
            <div className="font-display text-2xl font-bold text-white">Ready to standardise your documentation?</div>
            <div className="mt-2 text-slate-400 text-sm">Set up your workspace in minutes.</div>
            <div className="mt-6 flex justify-center gap-3">
              <Link to="/signup" className="fx-btn-primary text-white px-5 py-2.5 rounded-lg font-medium">Start free</Link>
              <Link to="/contact" className="border border-white/10 hover:border-white/20 text-slate-200 px-5 py-2.5 rounded-lg">Talk to sales</Link>
            </div>
          </div>
        </section>
      )}
      <PublicFooter />
    </div>
  );
}
